export default {
  title: 'Idioma',
  save_changes: 'Guardar alterações',
};
